// required config:
import { EnvironmentProviders, Provider } from "@angular/core";
import {
    DIFFICULT_QUESTION_ELEMENT_BASE_URL,
    VOTING_ELEMENT_BASE_URL,
    SLIDE_SYNC_HTML_ELEMENT_BASE_URL,
} from "shared/classroom/preview-screen/slide-rendering";


export type SharedClassroomPreviewScreenFeatureShellModuleConfig = {
    votingElementBaseUrl: string;
    difficultQuestionElementBaseUrl: string;
    htmlElementBaseUrl: string;
};

export const provideModuleConfig = (config: SharedClassroomPreviewScreenFeatureShellModuleConfig): (Provider | EnvironmentProviders)[] => [
    {
        provide: VOTING_ELEMENT_BASE_URL,
        useValue: config.votingElementBaseUrl,
    },
    {
        provide: DIFFICULT_QUESTION_ELEMENT_BASE_URL,
        useValue: config.difficultQuestionElementBaseUrl,
    },
    {
        provide: SLIDE_SYNC_HTML_ELEMENT_BASE_URL,
        useValue: config.htmlElementBaseUrl,
    },
];
